// extracted by mini-css-extract-plugin
export default {"user_info":"notification_user_info__3M3+7","rightContent":"notification_rightContent__7q-VC","rightContent_scroll":"notification_rightContent_scroll__gMNB3"};